import { createStore } from 'redux';
import hectorApp from '../reducers';


const initState = {
    animation: {
        visible: true
    },
    drawer: {
        open: false,
        content: null
    },
    posts: []
}

const store = createStore(hectorApp, initState);

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js